import { useState } from 'react'
import { Box, SxProps } from '@mui/material'
import utils from 'helpers/utils'
import useEffectOnce from 'hooks/useEffectOnce'
import useShowError from 'hooks/useShowError'
import axios from 'providers/axios'

type Props = {
  sx?: SxProps
}

const SignUpTotalSaving: React.FC<Props> = (props: Props) => {
  const showError = useShowError()

  const [saving, setSaving] = useState<number>(0)

  useEffectOnce(() => {
    const fetchProduct = async () => {
      try {
        const url = '/sign-up/totalSaving'
        const { data } = await axios.get(url)
        console.log(data)
        setSaving(data.saving)
      } catch (error) {
        showError(error)
      }
    }

    fetchProduct()
  })

  return (
    <Box
      sx={{
        ...props.sx,
        background: 'var(--yellow)',
        color: 'black',
        fontSize: '15px',
        width: 'fit-content',
        boxSizing: 'border-box',
        fontWeight: '400',
        marginBottom: '20px',
        borderRadius: '28px',
        padding: '8px 15px',
      }}
    >
      Total savings of{' '}
      <Box component="span" sx={{ fontWeight: '700' }}>
        {utils.priceFormatedUSDNoDecimals(saving)}/year
      </Box>{' '}
      available!
    </Box>
  )
}

export default SignUpTotalSaving
